<template>
  <div>
    <!-- 筛选 -->
    <filter-panel :data="group"
                  @search="change"></filter-panel>
    <!-- 列表 -->
    <data-list :table-style="{ name: 'mixture' }"
               :data="data"
               :columns="columns"
               :loading="loading"
               :page="page"
               :page-size="page.pageSize"
               :btnList="btnList"
               :hint="hint"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @sort-change="sortChange"></data-list>
    <!-- 详情模态框 -->
    <dialog-form :dialogVisible="showDialog"
                 :attributes="attributes"
                 :showBtn="false"
                 @close:dialogVisible="(val) => {showDialog = val}">
      <div slot="title"
           class="dialog-title">评价详情</div>
      <div class="evaluate-detail"
           slot="main">
        <div class="evaluate-item">
          <div class="item-title">服务人员：</div>
          <div class="item-data bgc">{{evaluationObjectName}}</div>
        </div>
        <div class="evaluate-item">
          <div class="item-title">态度评分：</div>
          <div class="item-data bgc">{{evaluateDetailData.attitudeScore}}</div>
        </div>
        <div class="evaluate-item">
          <div class="item-title">态度标签：</div>
          <div class="item-data">
            <el-tag v-for="item in attitudeLabel"
                    :key="item">{{item}}</el-tag>
          </div>
        </div>
        <div class="evaluate-item">
          <div class="item-title">能力评分：</div>
          <div class="item-data bgc">{{evaluateDetailData.abilityScore}}</div>
        </div>
        <div class="evaluate-item">
          <div class="item-title">能力标签：</div>
          <div class="item-data">
            <el-tag v-for="item in abilityLabel"
                    :key="item">{{item}}</el-tag>
          </div>
        </div>
        <div class="evaluate-item">
          <div class="item-title">评价：</div>
          <div class="item-data bgc">{{evaluateDetailData.remark}}</div>
        </div>
      </div>
    </dialog-form>
  </div>
</template>

<script>
import { getTodayDate } from '@/common/util.js'
import api from '@/backend/apiConfig/apiConfig'
import customerMinxins from '@/mixins/customer'
import evaluate from '@/backend/services/kit/kit.js'
import listPageCreate from '@/mixins/listPageCreate'
import dialogForm from '@/components/dialogForm/dialogForm'
import { evaluationType, evaluationStatus } from '@/common/dictionary.js'
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue'
const list = listPageCreate({
  searchConfig: {
    api: api.kit.evaluateList,
    method: 'POST'
  },
  getQuery (obj) {
    if (typeof obj.evaluationStatus == 'undefined') {
      obj.evaluationStatus = 1
    }
    return obj
  }
})
export default {
  name: 'evaluation',
  mixins: [list, customerMinxins],
  data () {
    return {
      group: {
        others: [
          {
            tagName: 'sky-input',
            placeholder: '服务人员',
            label: '服务人员',
            prop: 'servicePersonnel',
            value: ''
          },
          {
            tagName: 'sky-date-picker',
            type: 'daterange',
            label: '发起时间',
            startPlaceholder: '发起开始时间',
            endPlaceholder: '发起结束时间',
            prop: ['startDate', 'endDate'],
            value: []
          },
          {
            tagName: 'sky-date-picker',
            type: 'daterange',
            label: '评论时间',
            startPlaceholder: '评论开始时间',
            endPlaceholder: '评论结束时间',
            prop: ['evaluationStartDate', 'evaluationEndDate'],
            value: []
          },
          {
            tagName: 'sky-input-extent',
            label: '评分',
            min: 1,
            max: 5,
            prop: ['minOverallScore', 'maxOverallScore'],
            attribute: {
              placeholder: '整体评分1-5'
            },
            value: []
          }
        ],
        multiples: [
          {
            defaultText: '评价类型',
            placeholder: '评价类型',
            label: '评价类型',
            options: evaluationType,
            prop: 'evaluationType',
            value: ''
          },
          {
            defaultText: '评价状态',
            placeholder: '评价状态',
            label: '评价状态',
            options: evaluationStatus,
            prop: 'evaluationStatus',
            value: 1
          }
        ]
      },
      btnList: [],
      hint: {},
      columns: [],
      showDialog: false,
      attributes: {
        width: '30%'
      },
      evaluateDetailData: ''
    }
  },
  computed: {
    evaluationObjectName () {
      if (!this.evaluateDetailData.evaluationObjectName) return '-'
      if (this.evaluateDetailData.evaluationObjectEnName) {
        return `${this.evaluateDetailData.evaluationObjectName}（${this.evaluateDetailData.evaluationObjectEnName}）`
      } else {
        return this.evaluateDetailData.evaluationObjectName
      }
    },
    attitudeLabel () {
      if (!this.evaluateDetailData.attitudeLabel) return []
      return JSON.parse(this.evaluateDetailData.attitudeLabel)
    },
    abilityLabel () {
      if (!this.evaluateDetailData.abilityLabel) return []
      return JSON.parse(this.evaluateDetailData.abilityLabel)
    }
  },
  mounted () {
    this.query()
    this.setColumn()
    this.evaluateStat()
  },
  methods: {
    setColumn () {
      let that = this
      this.columns = [
        {
          label: '客户名称',
          bind: 'customerName',
          showOverflowTooltip: true
        },
        {
          label: '评价类型',
          bind: 'evaluationType',
          type: 'percentage',
          dataStyle (val) {
            switch (val) {
              case '0':
                return '订单评价'
              case '1':
                return '服务评价'
              case '2':
                return '月度评价'
            }
          }
        },
        {
          label: '评价人员类型',
          bind: 'evaluationObjectPosition',
          type: 'percentage',
          dataStyle (val) {
            switch (val) {
              case '1':
                return '网建顾问'
              case '2':
                return '询盘顾问'
              case '3':
                return '商务顾问'
              case '4':
                return '视频顾问'
            }
          }
        },
        {
          label: '服务人员',
          bind: 'evaluationObjectName'
        },
        {
          label: '客户联系人',
          bind: 'contact'
        },
        {
          label: '评价状态',
          bind: 'evaluationStatus',
          type: 'percentage',
          dataStyle (val) {
            switch (val) {
              case '0':
                return '未评价'
              case '1':
                return '已评价'
              case '2':
                return '已失效'
            }
          }
        },
        {
          label: '整体评分',
          bind: 'overallScore',
          type: 'percentage',
          dataStyle (val) {
            if (val) return val
            return '-'
          }
        },
        {
          label: '态度',
          bind: 'attitudeScore',
          type: 'percentage',
          dataStyle (val) {
            if (val) return val
            return '-'
          }
        },
        {
          label: '能力',
          bind: 'abilityScore',
          type: 'percentage',
          dataStyle (val) {
            if (val) return val
            return '-'
          }
        },
        {
          label: '发起时间',
          bind: 'createTime',
          type: 'percentage',
          dataStyle (val) {
            return val.slice(0, 10)
          }
        },
        {
          label: '评论时间',
          bind: 'evaluationTime',
          type: 'percentage',
          dataStyle (val) {
            if (!val) return '-'
            return val.slice(0, 10)
          }
        },
        {
          label: '详情',
          type: 'btnClick',
          bind: [
            {
              text: '详情',
              trigger (row) {
                that.evaluateDetail(row.evaluationId)
              }
            }
          ]
        }
      ]
      this.btnList = [
        {
          name: '导出',
          position: 'right',
          attribute: {
            type: 'primary',
            size: 'small'
          },
          btnClick () {
            that.download()
          }
        }
      ]
    },
    // filter change
    change (val) {
      this.filterChange(val)
      this.evaluateStat()
    },
    // 汇总筛选数据
    filterParamsData () {
      let { others, multiples } = this.group
      let params = {}
      others.forEach(item => {
        if (Array.isArray(item.prop)) {
          item.prop.forEach((val, idx) => {
            params[val] = item.value.length !== 0 ? item.value[idx] : ''
          })
        } else {
          params[item.prop] = item.value
        }
      })

      multiples.forEach(item => {
        params[item.prop] = item.value
      })
      return params
    },
    // 统计
    async evaluateStat () {
      let params = this.filterParamsData()
      let res = await evaluate.evaluateStat(params)
      this.hint = {
        content: `总计已评价${res.data.total || 0}条  均分${res.data.avgScore}`
      }
    },
    // 导出
    async download () {
      try {
        let params = this.filterParamsData()
        let res = await evaluate.evaluateExport(params)

        let blob = new Blob([res.data])
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', `全球赢客户评价${getTodayDate()}.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        this.$message.info('数据导出失败！')
      }
    },
    // 详情
    async evaluateDetail (id) {
      try {
        let res = await evaluate.evaluateDetail({ id })
        this.evaluateDetailData = res.data
        this.showDialog = true
      } catch (error) {
        this.showDialog = false
      }
    }
  },
  components: { filterPanel, dialogForm }
}
</script>

<style lang="scss" scoped>
.dialog-title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  line-height: 22px;
}
.evaluate-detail {
  width: 100%;
  .evaluate-item {
    width: 100%;
    padding: 3px 8px;
    margin: 10px 0;
    color: #333;

    display: flex;
    align-items: center;
    .item-title {
      width: 80px;
    }
    .item-data {
      flex: 1;
      .el-tag {
        height: 28px;
        line-height: 26px;
        color: #5e9df8;
        margin: 2px 4px;
        background-color: #ddecfe;
      }
      // span {
      //   /* 自动换行 */
      //   word-break: break-all;

      //   display: inline-block;
      //   padding: 4px 4px;
      //   border-radius: 4px;
      //   margin: 2px 4px;
      //   background-color: #f2f2f2;
      // }
    }
    .bgc {
      padding: 8px 8px;
      border-radius: 6px;
    }
  }
}
</style>
